/* eslint-enable */
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import router from './router'
// import { sync } from 'vuex-router-sync'
import store from './store'
import moment from 'vue-moment'
// import { StyledVue } from 'styled-vue'
// eslint-disable-next-line no-unused-vars
import customizeValidate from './utils/customizeValidate'
import { truncate } from './utils'

Vue.use(moment)
window.moment = require('moment')
window.moment.locale('ja', {weekdays: ['日', '月', '火', '水', '木', '金', '土']})
// sync(store, router)
// Vue.use(StyledVue)
// import filter
Vue.filter('truncate', truncate)

router.beforeEach((to, from, next) => {
  router['referrer'] = from
  next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js